import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import OptimizeModule from 'views/OptimizeView/OptimizeModule'

export default function OptimizeView(): ReactElement {
  const { t } = useTranslation()

  return <OptimizeModule regularOptJobType="regular" title={t('Production plan')} moduleName="optimize" />
}
